import axios from "axios";
import { configService } from "@/infrastructure/services/ConfigService";
import { logger } from "./LoggerService";
export class ApiPaymentLogService {
    constructor(baseUrl) {
        Object.defineProperty(this, "baseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const apiConfig = configService.api;
        this.baseUrl = baseUrl || apiConfig?.baseUrl || "http://localhost:8080/api/v1";
    }
    async logPaymentEvent(logData) {
        try {
            logger.debug("Logging payment event:", {
                status: logData.status,
                createdAt: logData.createdAt,
            });
            // public endpoint - no auth required
            const response = await axios.post(`${this.baseUrl}/public/payment/result`, logData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            logger.debug("Payment event logged successfully:", response.data);
            // Handle different response formats from the backend
            if (response.data?.success !== undefined) {
                return response.data;
            }
            // If the backend returns a different format, normalize it
            return {
                success: true,
                message: "Payment event logged successfully",
                logId: response.data?.id || response.data?.logId,
            };
        }
        catch (error) {
            logger.debug("Failed to log payment event:", error);
            // Don't throw error for logging failures - just return failure response
            // This ensures payment flow continues even if logging fails
            return {
                success: false,
                message: error instanceof Error
                    ? error.message
                    : "Unknown error occurred while logging payment event",
            };
        }
    }
}
